import React, { useEffect, useState } from "react";
import axios from "axios";


export default function MessagePage({ search }) {
  const API = "https://api.allianceprotravaux.be/api";
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadMessages = async () => {
    try {
      setLoading(true);

      const response = await axios.get(API + "/contacts");
      console.log(response.data);
      const data = response.data;

      setMessages(
        data.map((m) => ({
          id: m.id,
          name: m.name,
          subject: m.subject,
          email: m.email,
          message: m.message,
          date: m.created_at,
        }))
      );
    } catch (err) {
      console.error("Messages error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMessages();
  }, []);

  const filtered = messages.filter((m) => {
    if (!search) return true;
    const q = search.toLowerCase();

    return (
      (m.name || "").toLowerCase().includes(q) ||
      (m.email || "").toLowerCase().includes(q) ||
      (m.message || "").toLowerCase().includes(q)
    );
  });

  const fmt = (d) => {
    try {
      const dt = new Date(d);
      return dt.toLocaleString();
    } catch {
      return "";
    }
  };

  return (
    <div className="table-wrapper">
      <div className="table-header">Messages</div>

      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        <button className="refresh-btn" onClick={loadMessages}>
          Rafraîchir
        </button>
      </div>

      {loading ? (
        <p>Chargement...</p>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Email</th>
              <th>Date</th>
              <th>Message</th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((m) => (
              <tr key={m.id}>
                <td>{m.name || "Anonyme"}</td>
                <td>{m.email || "—"}</td>
                <td>{fmt(m.date)}</td>
                <td>{m.message}</td>
              </tr>
            ))}

            {filtered.length === 0 && (
              <tr>
                <td colSpan="4">Aucun message</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}